import { useEffect } from 'react';
import { siteConfig, generateOrganizationSchema, generateLocalBusinessSchema } from '../utils/seo';

interface SEOProps {
  title?: string;
  description?: string;
  path?: string;
  image?: string;
}

export function SEO({ title, description, path, image }: SEOProps) {
  useEffect(() => {
    const fullTitle = title 
      ? `${title} | ${siteConfig.name}` 
      : `${siteConfig.name} - ${siteConfig.tagline}`;
    
    document.title = fullTitle;
    
    // Update meta tags
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', description || siteConfig.description);
    }

    // Add structured data
    const organizationScript = document.createElement('script');
    organizationScript.type = 'application/ld+json';
    organizationScript.text = JSON.stringify(generateOrganizationSchema());
    
    const localBusinessScript = document.createElement('script');
    localBusinessScript.type = 'application/ld+json';
    localBusinessScript.text = JSON.stringify(generateLocalBusinessSchema());

    document.head.appendChild(organizationScript);
    document.head.appendChild(localBusinessScript);

    return () => {
      document.head.removeChild(organizationScript);
      document.head.removeChild(localBusinessScript);
    };
  }, [title, description, path, image]);

  return null;
}
